import React from 'react';
import { Link, useLocation } from 'react-router';
import { t } from 'i18next';
import { Topbar, TopbarSearch, type TopbarItem } from '@datanomik/core-ui';

export interface TopbarChromeProps {
  items: TopbarItem[];
  brand?: React.ReactNode;
  actions?: React.ReactNode;
  hidden?: boolean;
  onSearch?: () => void;
  searchLabel?: string;
}

export const TopbarChrome: React.FC<TopbarChromeProps> = ({
  items,
  brand,
  actions,
  hidden,
  onSearch,
  searchLabel = t('What do you want to do?'),
}) => {
  const { pathname, search } = useLocation();

  return (
    <Topbar
      data-modern
      items={items}
      linkAs={Link}
      routeKey={`${pathname}${search}`}
      brand={brand}
      search={onSearch ? <TopbarSearch label={searchLabel} onClick={onSearch} /> : undefined}
      actions={actions}
      hidden={hidden}
      lockedLabel={t('Blocked')}
    />
  );
};

export default TopbarChrome;
